export const CONTENT_TYPES = {
  url: 'url',
  text: 'text',
  email: 'email',
  call: 'call',
  sms: 'sms',
  vcard: 'vcard',
  wifi: 'wifi',
};

/** @deprecated use CONTENT_TYPES.call */
export const PHONE_TYPE = CONTENT_TYPES.call;

function escapeVCard(value) {
  return String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\n/g, '\\n');
}

export function buildFullPhone(countryCode, phone) {
  const code = (countryCode || '').trim().replace(/\s/g, '');
  const number = (phone || '').trim().replace(/[\s-]/g, '');
  if (!number) return '';
  if (number.startsWith('+')) return number;
  if (code) {
    const normalizedCode = code.startsWith('+') ? code : `+${code}`;
    return `${normalizedCode}${number.replace(/^0+/, '')}`;
  }
  return number.startsWith('tel:') ? number.slice(4) : number;
}

export function buildQrValue(type, fields) {
  switch (type) {
    case CONTENT_TYPES.url: {
      const raw = (fields.url || '').trim();
      if (!raw) return '';
      if (/^https?:\/\//i.test(raw)) return raw;
      return `https://${raw}`;
    }
    case CONTENT_TYPES.text:
      return (fields.text || '').trim();
    case CONTENT_TYPES.email: {
      const address = (fields.emailAddress || '').trim();
      if (!address) return '';
      const params = new URLSearchParams();
      const subject = (fields.emailSubject || '').trim();
      const body = (fields.emailBody || '').trim();
      if (subject) params.set('subject', subject);
      if (body) params.set('body', body);
      const query = params.toString();
      return query ? `mailto:${address}?${query}` : `mailto:${address}`;
    }
    case CONTENT_TYPES.call: {
      const full = buildFullPhone(fields.callCountryCode, fields.callPhone);
      if (!full) return '';
      return full.startsWith('tel:') ? full : `tel:${full}`;
    }
    case CONTENT_TYPES.sms: {
      const full = buildFullPhone(fields.smsCountryCode, fields.smsPhone);
      if (!full) return '';
      const message = (fields.smsMessage || '').trim();
      const params = new URLSearchParams();
      if (message) params.set('body', message);
      const query = params.toString();
      return query ? `sms:${full}?${query}` : `sms:${full}`;
    }
    case CONTENT_TYPES.vcard: {
      const firstName = (fields.vcardFirstName || '').trim();
      const lastName = (fields.vcardLastName || '').trim();
      const hasAny =
        firstName ||
        lastName ||
        (fields.vcardPhone || '').trim() ||
        (fields.vcardMobile || '').trim() ||
        (fields.vcardEmail || '').trim() ||
        (fields.vcardCompany || '').trim();
      if (!hasAny) return '';

      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      const lines = ['BEGIN:VCARD', 'VERSION:3.0'];
      lines.push(`N:${escapeVCard(lastName)};${escapeVCard(firstName)};;;`);
      if (fullName) lines.push(`FN:${escapeVCard(fullName)}`);
      if (fields.vcardPhone?.trim()) {
        lines.push(`TEL;TYPE=WORK,VOICE:${escapeVCard(fields.vcardPhone.trim())}`);
      }
      if (fields.vcardMobile?.trim()) {
        lines.push(`TEL;TYPE=CELL:${escapeVCard(fields.vcardMobile.trim())}`);
      }
      if (fields.vcardFax?.trim()) {
        lines.push(`TEL;TYPE=FAX:${escapeVCard(fields.vcardFax.trim())}`);
      }
      if (fields.vcardEmail?.trim()) {
        lines.push(`EMAIL:${escapeVCard(fields.vcardEmail.trim())}`);
      }
      if (fields.vcardWebsite?.trim()) {
        let url = fields.vcardWebsite.trim();
        if (!/^https?:\/\//i.test(url)) url = `https://${url}`;
        lines.push(`URL:${escapeVCard(url)}`);
      }
      if (fields.vcardCompany?.trim()) {
        lines.push(`ORG:${escapeVCard(fields.vcardCompany.trim())}`);
      }
      if (fields.vcardJobTitle?.trim()) {
        lines.push(`TITLE:${escapeVCard(fields.vcardJobTitle.trim())}`);
      }
      lines.push('END:VCARD');
      return lines.join('\n');
    }
    case CONTENT_TYPES.wifi: {
      const ssid = (fields.wifiSsid || '').trim();
      if (!ssid) return '';
      const encryption = fields.wifiEncryption || 'WPA';
      const password = (fields.wifiPassword || '').replace(/[;\\",:]/g, '\\$&');
      const hidden = fields.wifiHidden ? 'true' : 'false';
      return `WIFI:T:${encryption};S:${ssid};P:${password};H:${hidden};;`;
    }
  }

  // Legacy alias
  if (type === 'phone') {
    return buildQrValue(CONTENT_TYPES.call, {
      callCountryCode: '',
      callPhone: fields.phone,
    });
  }

  return '';
}

export const DEFAULT_FIELDS = {
  url: 'https://pixelutility.com',
  text: '',
  emailAddress: '',
  emailSubject: '',
  emailBody: '',
  callCountryCode: '+370',
  callPhone: '',
  smsCountryCode: '+370',
  smsPhone: '',
  smsMessage: '',
  vcardFirstName: '',
  vcardLastName: '',
  vcardPhone: '',
  vcardMobile: '',
  vcardEmail: '',
  vcardWebsite: '',
  vcardCompany: '',
  vcardJobTitle: '',
  vcardFax: '',
  wifiSsid: '',
  wifiPassword: '',
  wifiEncryption: 'WPA',
  wifiHidden: false,
};

export const DEFAULT_STYLE = {
  fgColor: '#0f172a',
  bgColor: '#ffffff',
  size: 256,
  margin: 2,
  dotsType: 'square',
  cornersSquareType: 'square',
  cornersDotType: 'square',
  frameType: 'none',
  framePhrase: 'SCAN ME',
  frameColor: '#0f172a',
  frameTextColor: '#ffffff',
  frameFont: 'sans-serif',
  logoUrl: '',
  logoSize: 0.4,
  logoMargin: 6,
};
